import { SortDirection } from '@core/models/common/sort-direction';

export function sortAlphabeticalByProperty(property, sortDirection: SortDirection = SortDirection.ASC) {
    if (sortDirection === SortDirection.ASC) {
        return (itemA: { [key: string]: string }, itemB: { [key: string]: string }) => {
            return itemA[property].localeCompare(itemB[property]);
        };
    } else {
        return (itemA: { [key: string]: string }, itemB: { [key: string]: string }) => {
            return itemB[property].localeCompare(itemA[property]);
        };
    }
}

export function sortNumericallyByProperty(property, sortDirection: SortDirection = SortDirection.ASC) {
    if (sortDirection === SortDirection.ASC) {
        return (itemA: { [key: string]: any }, itemB: { [key: string]: any }) => {
            return itemA[property] - itemB[property];
        };
    } else {
        return (itemA: { [key: string]: any }, itemB: { [key: string]: any }) => {
            return itemB[property] - itemA[property];
        };
    }
}
